import client from './client';

// Cached, OSM-sourced roads for a tenant (see backend/app/services/osm_roads.py).
// Response: { tenant_id, version, roads: [{id, name, segments, point}], total }.
export const listOsmRoads = (tenantId) =>
  client.get(`/osm-roads/by-tenant/${tenantId}`).then((r) => r.data);

// Admin-triggered re-fetch from OpenStreetMap (Overpass) for the tenant's
// primary boundary. Response: { tenant_id, version, road_count, way_count }.
export const refreshOsmRoads = (tenantId) =>
  client.post('/osm-roads/admin/refresh', { tenant_id: tenantId }).then((r) => r.data);
